<template>
  <div>
    <div class="web-header">
      <div class="web-header__info">
        <svg width="16" height="16" viewBox="0 0 16 16">
          <g transform="translate(-362 -206)">
            <g transform="translate(362 206)" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8,16A8,8,0,1,0,0,8,8.024,8.024,0,0,0,8,16Z" stroke="none"/>
              <path d="M 8 14.5 C 9.727370262145996 14.5 11.3572301864624 13.82145023345947 12.58934020996094 12.58934020996094 C 13.82145023345947 11.3572301864624 14.5 9.727370262145996 14.5 8 C 14.5 6.272630214691162 13.82145023345947 4.642769813537598 12.58934020996094 3.410660028457642 C 11.3572301864624 2.178550004959106 9.727370262145996 1.5 8 1.5 C 6.272630214691162 1.5 4.642769813537598 2.178550004959106 3.410660028457642 3.410660028457642 C 2.178550004959106 4.642769813537598 1.5 6.272630214691162 1.5 8 C 1.5 9.727370262145996 2.178550004959106 11.3572301864624 3.410660028457642 12.58934020996094 C 4.642769813537598 13.82145023345947 6.272630214691162 14.5 8 14.5 M 8 16 C 3.599999904632568 16 0 12.39999961853027 0 8 C 0 3.599999904632568 3.599999904632568 0 8 0 C 12.39999961853027 0 16 3.599999904632568 16 8 C 16 12.39999961853027 12.39999961853027 16 8 16 Z" stroke="none" fill="#92a3be"/>
            </g>
            <g transform="translate(596.25 435.729) rotate(180)">
              <path d="M12,7.92v3.7" transform="translate(214.25 210.207)" fill="none" stroke="#92a3be" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              <path d="M12,16.08a.75.75,0,1,0-.75-.75A.75.75,0,0,0,12,16.08Z" transform="translate(214.25 209.25)" fill="#92a3be"/>
            </g>
          </g>
        </svg>

        Для того чтобы получать уведомления в Telegram, напишите боту и пришлите ID
        <a target="_blank" href="https://t.me/BadenSpaBot">https://t.me/BadenSpaBot</a>
      </div>

      <div class="web-header__nav">
        <a href="/bitrix"  class="nav-bitrix" v-if="USER && USER['IS_ADMIN']">
          <img src="data:image/png;base64,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"/>
        </a>
        <router-link to="/profile" v-if="USER" class="nav-profile">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M12 12C9.24 12 7 9.76 7 7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7C17 9.76 14.76 12 12 12ZM12 4C10.34 4 9 5.34 9 7C9 8.66 10.34 10 12 10C13.66 10 15 8.66 15 7C15 5.34 13.66 4 12 4ZM20 22H4V21C4 16.58 7.58 13 12 13C16.42 13 20 16.58 20 21V22ZM6.08 20H17.92C17.38 16.73 14.29 14.52 11.02 15.06C8.49 15.47 6.5 17.46 6.08 20Z" fill="#1565C0"/> </svg>
          <span>{{USER['EMAIL']}}</span>
        </router-link>
      </div>
    </div>
    <template v-if="loading">
      <Loader />
    </template>
    <div class="web-container chess" v-else>
      <div class="chess-cover">
        <div class="chess-head">
          <div class="left-col">
            <div class="flex">
              <div>
                <Datepicker
                    :monday-first="true"
                    :value="date"
                    :iconColor="'#406080'"
                    :clearable="false"
                    :iconWidth="13"
                    :iconHeight="13"
                    :weekStartsOn="1"
                    :locale="'ru'"
                    :full-month-name="true"
                    :calendar-button="false"
                    @selected="selectedDate"
                    :language="'ru'"
                    :inputFormat="'dd.MM.yyyy'"/>
              </div>
              <div class="button-today" @click="updateDate('date', new Date())">
                <div class="data-title">
                  Сегодня: <br> {{new Date().getDate()}}.{{String(new Date().getMonth() + 1).length > 1 ? new Date().getMonth() + 1 : "0" + (new Date().getMonth() + 1)}}.{{new Date().getFullYear()}}
                </div>
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <g transform="translate(-310 -291)">
                    <g transform="translate(307.25 288.25)" fill="none" stroke-linecap="round" stroke-linejoin="round" fill-rule="evenodd">
                      <path d="M22.75,12.75a10,10,0,1,1-10-10A10,10,0,0,1,22.75,12.75Z" stroke="none"/>
                      <path d="M 12.74979496002197 21.25049018859863 C 17.43671417236328 21.25049018859863 21.24979400634766 17.43741035461426 21.24979400634766 12.7504997253418 C 21.24979400634766 8.063580513000488 17.43671417236328 4.250490188598633 12.74979496002197 4.250490188598633 C 8.062885284423828 4.250490188598633 4.249804973602295 8.063580513000488 4.249804973602295 12.7504997253418 C 4.249804973602295 17.43741035461426 8.062885284423828 21.25049018859863 12.74979496002197 21.25049018859863 M 12.74979496002197 22.75049018859863 C 7.226554870605469 22.75049018859863 2.749804973602295 18.27374076843262 2.749804973602295 12.7504997253418 C 2.749804973602295 7.227240085601807 7.226554870605469 2.750490188598633 12.74979496002197 2.750490188598633 C 18.27303504943848 2.750490188598633 22.74979400634766 7.227240085601807 22.74979400634766 12.7504997253418 C 22.74979400634766 18.27374076843262 18.27303504943848 22.75049018859863 12.74979496002197 22.75049018859863 Z" stroke="none" fill="currentColor"/>
                    </g>
                    <path d="M14.445,13.086l-2.784-1.661V7.847" transform="translate(307.972 290.217)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                  </g>
                </svg>
              </div>
            </div>
            <div class="drop-all" @click="dropAll()">
              <svg width="9.12" height="5.914" viewBox="0 0 9.12 5.914" :style="{transform: `rotate(${all_open ? '180deg' : '0'})`}">
                <g transform="translate(1.06 1.06)">
                  <path d="M11.81,18.544,8.31,14.75" transform="translate(-8.31 -14.75)" fill="none" stroke="#92a3be" stroke-linecap="round" stroke-width="1.5"></path>
                  <path d="M12,18.544l3.5-3.794" transform="translate(-8.5 -14.75)" fill="none" stroke="#92a3be" stroke-linecap="round" stroke-width="1.5"></path>
                </g>
              </svg>
              Категории номеров
            </div>
          </div>
          <div class="right-col">
            <div class="right-col__months">
              <div class="btn-arrow btn-arrow_prev" @click="updateDate('prev')">
                <svg width="10.914" height="9.12" viewBox="0 0 10.914 9.12">
                  <g transform="translate(-1066.272 -737.44)">
                    <g transform="translate(1071.126 738.5) rotate(90)">
                      <path d="M11.81,18.544,8.31,14.75" transform="translate(-8.31 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                      <path d="M12,18.544l3.5-3.794" transform="translate(-8.5 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                    </g>
                    <g transform="translate(1076.126 738.5) rotate(90)">
                      <path d="M11.81,18.544,8.31,14.75" transform="translate(-8.31 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                      <path d="M12,18.544l3.5-3.794" transform="translate(-8.5 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                    </g>
                  </g>
                </svg>
              </div>
              <div v-html="colMonth()" style="flex-grow: 1; display: flex"></div>
              <div class="btn-arrow btn-arrow_next" @click="updateDate('next')">
                <svg width="10.914" height="9.12" viewBox="0 0 10.914 9.12">
                  <g transform="translate(1077.186 746.56) rotate(180)">
                    <g transform="translate(1071.126 738.5) rotate(90)">
                      <path d="M11.81,18.544,8.31,14.75" transform="translate(-8.31 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                      <path d="M12,18.544l3.5-3.794" transform="translate(-8.5 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                    </g>
                    <g transform="translate(1076.126 738.5) rotate(90)">
                      <path d="M11.81,18.544,8.31,14.75" transform="translate(-8.31 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                      <path d="M12,18.544l3.5-3.794" transform="translate(-8.5 -14.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div v-html="colDay()" class="right-col__days"></div>
          </div>
        </div>
        <div v-if="LOADING" class="chess-body chess-body_loading">
          <Loader />
        </div>
        <div class="chess-body" v-else>
          <template v-if="DATA && Object.keys(DATA).length">
            <div :class="['chess-line', el['OPEN'] ? 'chess-line_open' : '']" v-for="(el, index) in DATA" :key="index" v-html="colDayUser(el)"></div>
          </template>
          <template v-else>
            <p><b>Нет данных</b></p>
          </template>
        </div>
      </div>
    </div>

    <div :class="['popup_info-wrap', POPUP ? 'open' : '']">
      <DetailPopup />
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import Loader from "@/components/LoaderComponent";
import DetailPopup from "@/components/DetailPopup";
import Datepicker from 'vuejs3-datepicker';

export default {
  name: "ChessPage",
  data() {
    return {
      loading: true,
      width: 0,
      count: 0,
      date: null,
      date_ms: 0,
      one_day: 86400000,
      weeks: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      month: ["Январь","Февряль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],
      all_open: true
    }
  },
  components: {
    Loader,
    Datepicker,
    DetailPopup,
  },
  computed: {
    ...mapGetters("User", ["USER"]),
    ...mapGetters("Chess", ["LOADING"]),
    ...mapGetters("Chess", ["DATA"]),
    ...mapGetters("Chess", ["POPUP"]),
    ...mapGetters("Chess", ["LINE_NAMES"]),
    /*locale: () => ru,*/
  },
  methods: {
    ...mapActions("User", ["fetchUser"]),
    ...mapActions("Chess", ["fetchData"]),
    ...mapActions("Chess", ["togglePopup"]),
    updateDate(type, date) {
      if (type === 'prev') {
        this.date = new Date(new Date(this.date).getTime() - (this.one_day * 5));
      }

      if (type === 'next') {
        this.date = new Date(new Date(this.date).getTime() + (this.one_day * 5));
      }

      if(type === 'date' && date) {
        this.date = new Date(new Date(date).getTime());
      }

      this.updateCols();
    },
    priceFormatting(price) {
      const resString = String(price).split(' ').join('');
      return resString.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    selectedDate(date) {
      if(date) {
        this.updateDate('date', date)
      }
    },
    //Линия месяца в шапке таблицы
    colMonth() {
      let string = "";
      let first_start = new Date(this.date);
      let first_end = new Date(new Date(first_start).getFullYear(), new Date(first_start).getMonth() + 1, 0);
      let first_count_day = (new Date(first_end).getTime() - new Date(first_start).getTime()) / this.one_day;
      string = `<div class="right-col__month" style="width: ${(first_count_day + 1) * 39}">
                    <p>${this.month[new Date(first_start).getMonth()]} ${new Date(first_start).getFullYear()}</p>
                </div>`;

      let start = new Date(new Date(this.date).getFullYear(), new Date(this.date).getMonth(), 1);
      let end = new Date(new Date(start).getFullYear(), new Date(start).getMonth() + 1, 0);
      let count_day = (new Date(end).getTime() - new Date(start).getTime()) / this.one_day;

      string = string + `<div class="right-col__month" style="width: ${(count_day + 1) * 39}">
                              <p>${this.month[new Date(start).getMonth() === 11 ? 0 : new Date(start).getMonth() + 1]} ${new Date(start).getFullYear()}</p>
                          </div>`;

      return string
    },
    //Линия дней в шапке таблицы
    colDay() {
      const _this = this;
      let string = "";
      for(let i = 0; i < Math.round(this.count); i++) {
        const col = new Date(new Date(this.date).getTime() + (this.one_day * i))
        string = string + `<div class="right-col__day">
        ${new Date(new Date().toDateString()).getTime() === new Date(new Date(col).toDateString()).getTime() ? '<i class="i-today"></i><i class="i-line js-i-line"></i>' : ''}
                            <p>${new Date(col).getDate()}</p>
                            <span>${this.weeks[new Date(col).getDay()]}</span>
                           </div>`;
      }
      return string
    },
    //Главная линия юзера
    colDayUser(el) {
      let head_left = this.colDayUserHeadLeft(el)
      let head_right = this.colDayUserHeadRight(el)
      let min_line = this.colDayUserLine(el);
      return `<div class="chess-line_head">${head_left} ${head_right}</div> ${min_line}`
    },
    //Левая колонка в главной линии юзера
    colDayUserHeadLeft(el) {
      return `<div class="left-col" onclick="document.toggleLine(${el['ID']})">
                <svg width="9.12" height="5.914" viewBox="0 0 9.12 5.914">
                  <g transform="translate(1.06 1.06)">
                    <path d="M11.81,18.544,8.31,14.75" transform="translate(-8.31 -14.75)" fill="none" stroke="#92a3be" stroke-linecap="round" stroke-width="1.5"/>
                    <path d="M12,18.544l3.5-3.794" transform="translate(-8.5 -14.75)" fill="none" stroke="#92a3be" stroke-linecap="round" stroke-width="1.5"/>
                  </g>
                </svg>
                № ${el['NAME']}
              </div>`
    },
    //Правая колонка линий дат в главной линии юзера
    colDayUserHeadRight(el) {
      let string = "";

      for(let i = 0; i < Math.round(this.count); i++) {
        const col_start = new Date(new Date(new Date(this.date).toDateString() + ' 23:59:59').getTime() + (this.one_day * i));
        const col_end = new Date(new Date(new Date(this.date).toDateString() + ' 23:59:59').getTime() + (this.one_day * i));
        let count = Object.keys(el['ITEMS']).length;
        Object.keys(el['ITEMS']).forEach(item => {
          Object.keys(el['ITEMS'][item]).forEach(obj => {
            const start = new Date(el['ITEMS'][item][obj]['CHECK_IN_DATE_TIME']).getTime();
            const end = new Date(el['ITEMS'][item][obj]['CHECK_OUT_DATE_TIME']).getTime();
            if(col_start > start  && col_end < end ) {
              count = count - 1
            }
          })
        })
        string = string + `<div class="right-col__day right-col__day_light">${count}</div>`;
      }

      return `<div class="right-col">
                <div  class="right-col__days">${string}</div>
              </div>`
    },
    //Линия номера (под главной линией юзера)
    colDayUserLine(el) {
      let min_line = "";
      if(el['ITEMS'] && Object.keys(el['ITEMS']).length) {
        Object.keys(el['ITEMS']).forEach(i => {
          if(i !== '0') {
            min_line = min_line + `<div class="chess-line_body">${this.colDayUserLineLeft([i])} ${this.colDayUserLineRight(el['ITEMS'][i], i, el['ID'])}</div>`
          }
        })
      }
      return min_line
    },
    //Левая колонка из Линия номера (под главной линией юзера)
    colDayUserLineLeft(name) {
      if(this.LINE_NAMES && this.LINE_NAMES[name]) {
        return `<div class="left-col">
                <div class="appart-name">
                  <span>
                    <div class="data-title">${this.LINE_NAMES[name]['ROOM_NAME']}</div>
                        ${this.LINE_NAMES[name]['ROOM_NAME']}
                    </span>
                  <div class="appart-info">
                    <div class="data-title">
                        ${this.LINE_NAMES[name]['RESPONSIBLE'] ? this.LINE_NAMES[name]['RESPONSIBLE']['FULL_NAME'] : ''}
                        ${this.LINE_NAMES[name]['RESPONSIBLE'] ? this.LINE_NAMES[name]['RESPONSIBLE']['PHONE'].map(el => el) : ''}
                        ${this.LINE_NAMES[name]['RESPONSIBLE'] ? this.LINE_NAMES[name]['RESPONSIBLE']['EMAIL'].map(el => el) : ''}
                    </div>
                    <svg width="16" height="16" viewBox="0 0 16 16">
                      <g transform="translate(-362 -206)">
                        <g transform="translate(362 206)" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M8,16A8,8,0,1,0,0,8,8.024,8.024,0,0,0,8,16Z" stroke="none"/>
                          <path d="M 8 14.5 C 9.727370262145996 14.5 11.3572301864624 13.82145023345947 12.58934020996094 12.58934020996094 C 13.82145023345947 11.3572301864624 14.5 9.727370262145996 14.5 8 C 14.5 6.272630214691162 13.82145023345947 4.642769813537598 12.58934020996094 3.410660028457642 C 11.3572301864624 2.178550004959106 9.727370262145996 1.5 8 1.5 C 6.272630214691162 1.5 4.642769813537598 2.178550004959106 3.410660028457642 3.410660028457642 C 2.178550004959106 4.642769813537598 1.5 6.272630214691162 1.5 8 C 1.5 9.727370262145996 2.178550004959106 11.3572301864624 3.410660028457642 12.58934020996094 C 4.642769813537598 13.82145023345947 6.272630214691162 14.5 8 14.5 M 8 16 C 3.599999904632568 16 0 12.39999961853027 0 8 C 0 3.599999904632568 3.599999904632568 0 8 0 C 12.39999961853027 0 16 3.599999904632568 16 8 C 16 12.39999961853027 12.39999961853027 16 8 16 Z" stroke="none" fill="#92a3be"/>
                        </g>
                        <g transform="translate(596.25 435.729) rotate(180)">
                          <path d="M12,7.92v3.7" transform="translate(214.25 210.207)" fill="none" stroke="#92a3be" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                          <path d="M12,16.08a.75.75,0,1,0-.75-.75A.75.75,0,0,0,12,16.08Z" transform="translate(214.25 209.25)" fill="#92a3be"/>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>`
      } else {
        return `<div class="left-col"></div>`
      }
    },
    //Правая колонка из Линия номера (под главной линией юзера)
    colDayUserLineRight(arr, child_id,  parent_id) {
      const _this = this;
      const _parent_id = parent_id;
      const _child_id = child_id;
      let string = "";
      for(let i = 0; i < Math.round(this.count); i++) {
        const day_start = new Date(new Date(new Date(this.date).toDateString() + ' 00:00:00').getTime() + (this.one_day * i));
        const day_end = new Date(new Date(new Date(this.date).toDateString() + ' 23:59:59').getTime() + (this.one_day * i));

        let event_lines = "";

        Object.keys(arr).forEach(el => {
          function dataContent() {
            const dateFormattingIn_h = String(new Date(arr[el]['CHECK_IN_DATE_TIME']).getHours()).length > 1 ? new Date(arr[el]['CHECK_IN_DATE_TIME']).getHours() : ('0' + (new Date(arr[el]['CHECK_IN_DATE_TIME']).getHours()));
            const dateFormattingIn_m = String(new Date(arr[el]['CHECK_IN_DATE_TIME']).getMinutes()).length > 1 ? new Date(arr[el]['CHECK_IN_DATE_TIME']).getMinutes() : ('0' + (new Date(arr[el]['CHECK_IN_DATE_TIME']).getMinutes()));
            const dateFormattingIn = new Date(arr[el]['CHECK_IN_DATE_TIME']).getDate() + ' ' +
                _this.month[new Date(arr[el]['CHECK_IN_DATE_TIME']).getMonth()] + ' (' +
                dateFormattingIn_h + ':' + dateFormattingIn_m + ')';
            const dateFormattingOut_h = String(new Date(arr[el]['CHECK_OUT_DATE_TIME']).getHours()).length > 1 ? new Date(arr[el]['CHECK_OUT_DATE_TIME']).getHours() : ('0' + (new Date(arr[el]['CHECK_OUT_DATE_TIME']).getHours()));
            const dateFormattingOut_m = String(new Date(arr[el]['CHECK_OUT_DATE_TIME']).getMinutes()).length > 1 ? new Date(arr[el]['CHECK_OUT_DATE_TIME']).getMinutes() : ('0' + (new Date(arr[el]['CHECK_OUT_DATE_TIME']).getMinutes()));
            const dateFormattingOut = new Date(arr[el]['CHECK_OUT_DATE_TIME']).getDate() + ' ' +
                _this.month[new Date(arr[el]['CHECK_OUT_DATE_TIME']).getMonth()] + ' (' +
                dateFormattingOut_h + ':' + dateFormattingOut_m + ')';
            return `
            <ul>
                <li>Проживание: ${dateFormattingIn} - ${dateFormattingOut}</li>
                <li>Гость: ${arr[el]['CUSTOMER']['LAST_NAME']} ${arr[el]['CUSTOMER']['FIRST_NAME'] ? arr[el]['CUSTOMER']['FIRST_NAME'][0] : ''}. ${arr[el]['CUSTOMER']['MIDDLE_NAME'] ? arr[el]['CUSTOMER']['MIDDLE_NAME'][0] : ''}.</li>
                <li>Источник: ${arr[el]['SOURCE']} <br> (${arr[el]['NUMBER']})</li>
                <li>Сумма по счетам брони: ${_this.priceFormatting(arr[el]['AMOUNT'])} ${arr[el]['CURRENCY_ID']}</li>
                <li>Оплачено по счетам номера: ${_this.priceFormatting(arr[el]['AMOUNT'] - arr[el]['TO_PAY_AMOUNT'])} ${arr[el]['CURRENCY_ID']}</li>
                <li>Баланс по брони: ${_this.priceFormatting(arr[el]['TO_PAY_AMOUNT'])} ${arr[el]['CURRENCY_ID']}</li>
            </ul>
            ${arr[el]['MAIL_STATUS'] === 'N' ? '<p class="mail-status mail-status_gray">' +
                '<svg width="16" height="16" viewBox="0 0 16 16"><g  transform="translate(-539 -430)"><g transform="translate(25.838 208.8)"><path d="M16.03,8.36V2.75H4.81V8.36" transform="translate(510.797 219.25)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.381,9.28a1.755,1.755,0,0,1,.8,1.475v6.109a1.758,1.758,0,0,1-1.756,1.756H4.506A1.758,1.758,0,0,1,2.75,16.864V10.755a1.755,1.755,0,0,1,.8-1.475" transform="translate(511.25 217.815)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.605,9.59l-5.36,4.689a1.6,1.6,0,0,1-2.114,0L3.77,9.59" transform="translate(511.026 217.747)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M14.13,15.01l4.752,4.065" transform="translate(508.749 216.556)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M3.78,19.09l4.806-4.01" transform="translate(511.024 216.54)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,5.83h.8" transform="translate(510.12 218.573)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,8.92H14.3" transform="translate(510.12 217.894)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></g></g></svg>' +
                'Не отправлено</p>' : ''}
            ${arr[el]['MAIL_STATUS'] === 'Y' ? '<p class="mail-status mail-status_green">' +
                '<svg width="16" height="16" viewBox="0 0 16 16"><g  transform="translate(-539 -430)"><g transform="translate(25.838 208.8)"><path d="M16.03,8.36V2.75H4.81V8.36" transform="translate(510.797 219.25)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.381,9.28a1.755,1.755,0,0,1,.8,1.475v6.109a1.758,1.758,0,0,1-1.756,1.756H4.506A1.758,1.758,0,0,1,2.75,16.864V10.755a1.755,1.755,0,0,1,.8-1.475" transform="translate(511.25 217.815)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.605,9.59l-5.36,4.689a1.6,1.6,0,0,1-2.114,0L3.77,9.59" transform="translate(511.026 217.747)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M14.13,15.01l4.752,4.065" transform="translate(508.749 216.556)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M3.78,19.09l4.806-4.01" transform="translate(511.024 216.54)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,5.83h.8" transform="translate(510.12 218.573)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,8.92H14.3" transform="translate(510.12 217.894)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></g></g></svg>' +
                'Успешно отправлено</p>' : ''}
            ${arr[el]['MAIL_STATUS'] === 'F' ? '<p class="mail-status mail-status_red">' +
                '<svg width="16" height="16" viewBox="0 0 16 16"><g  transform="translate(-539 -430)"><g transform="translate(25.838 208.8)"><path d="M16.03,8.36V2.75H4.81V8.36" transform="translate(510.797 219.25)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.381,9.28a1.755,1.755,0,0,1,.8,1.475v6.109a1.758,1.758,0,0,1-1.756,1.756H4.506A1.758,1.758,0,0,1,2.75,16.864V10.755a1.755,1.755,0,0,1,.8-1.475" transform="translate(511.25 217.815)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.605,9.59l-5.36,4.689a1.6,1.6,0,0,1-2.114,0L3.77,9.59" transform="translate(511.026 217.747)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M14.13,15.01l4.752,4.065" transform="translate(508.749 216.556)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M3.78,19.09l4.806-4.01" transform="translate(511.024 216.54)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,5.83h.8" transform="translate(510.12 218.573)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,8.92H14.3" transform="translate(510.12 217.894)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></g></g></svg>' +
                'Ошибка отправки</p>' : ''}
            ${arr[el]['MAIL_STATUS'] === 'P' ? '<p class="mail-status mail-status_orange">' +
                '<svg width="16" height="16" viewBox="0 0 16 16"><g  transform="translate(-539 -430)"><g transform="translate(25.838 208.8)"><path d="M16.03,8.36V2.75H4.81V8.36" transform="translate(510.797 219.25)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.381,9.28a1.755,1.755,0,0,1,.8,1.475v6.109a1.758,1.758,0,0,1-1.756,1.756H4.506A1.758,1.758,0,0,1,2.75,16.864V10.755a1.755,1.755,0,0,1,.8-1.475" transform="translate(511.25 217.815)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M16.605,9.59l-5.36,4.689a1.6,1.6,0,0,1-2.114,0L3.77,9.59" transform="translate(511.026 217.747)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M14.13,15.01l4.752,4.065" transform="translate(508.749 216.556)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M3.78,19.09l4.806-4.01" transform="translate(511.024 216.54)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,5.83h.8" transform="translate(510.12 218.573)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.89,8.92H14.3" transform="translate(510.12 217.894)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></g></g></svg>' +
                'Частично отправлено</p>' : ''}
            `
          }

          if (arr[el]) {
            const el_start = new Date(arr[el]['CHECK_IN_DATE_TIME']).getTime();
            const el_end = new Date(arr[el]['CHECK_OUT_DATE_TIME']).getTime();
            const count_day = el_end - el_start;
            const condition = el_start > new Date(day_start).getTime() && el_start < new Date(day_end).getTime();

            const condition_end = el_start < new Date(this.date).getTime() && el_end < new Date(day_end).getTime();

            if(arr[el]['CLOSED']) {
              if(condition) {
                const html_day = `
              <div class="event event_close" style="width: ${(39 * (count_day / this.one_day))}px">
                <div class="event-name">
                   ${arr[el]['CUSTOMER']['FIRST_NAME']}
                </div>
              </div>`;
                event_lines = event_lines + html_day
              }
              if(condition_end && (new Date(el_end).getDate() === new Date(day_end).getDate() && new Date(el_end).getMonth() === new Date(day_end).getMonth())) {
                const html_day = `
                    <div class="event event_close event_left" style="width: ${(39 * (count_day / this.one_day))}px">
                        <div class="event-name">${arr[el]['CUSTOMER']['FIRST_NAME']}</div>
                    </div>`;
                event_lines = event_lines + html_day
              }
            } else {
              if(condition) {
                const html_day = `
              <div class="event ${new Date(arr[el]['CHECK_IN_DATE_TIME']).getTime() > new Date().getTime() ? 'event_green' : 'event_red'}"
              style="width: ${(39 * (count_day / this.one_day))}px" onclick="document.openPopup(${_parent_id}, ${_child_id}, ${el})">
                <div class="data-title ${(i > Math.round(_this.count)/4) ? "data-title_left" : ""}">
                  ${dataContent()}
                </div>
                <div class="event-name ${+arr[el]['TO_PAY_AMOUNT'] === 0 ? 'event-name_green' : ''}">
                    ${arr[el]['CUSTOMER']['FULL_NAME']}
                    ${this.priceFormatting(+arr[el]['AMOUNT'] - +arr[el]['TO_PAY_AMOUNT']) !== 0 ?
                    ('<span>' + (this.priceFormatting(arr[el]['AMOUNT'] - arr[el]['TO_PAY_AMOUNT'])) +'</span>') : ''}
                </div>
              </div>`;
                event_lines = event_lines + html_day
              }
              if(condition_end && (new Date(el_end).getDate() === new Date(day_end).getDate() && new Date(el_end).getMonth() === new Date(day_end).getMonth())) {
                const html_day = `
            <div class="event event_left ${new Date(arr[el]['CHECK_IN_DATE_TIME']).getTime() > new Date().getTime() ? 'event_green' : 'event_red'}"
            style="width: ${(39 * (count_day / this.one_day))}px" onclick="document.openPopup(${_parent_id}, ${_child_id}, ${el})">
                <div class="data-title">
                    ${dataContent()}
                </div>
                <div class="event-name">${arr[el]['CUSTOMER']['FULL_NAME']}</div>
            </div>`;
                event_lines = event_lines + html_day
              }
            }
          }
        })

        string = string +
          `<div class="right-col__day" data-date="${day_start.toDateString()}">
            ${event_lines}
           </div>`;
      }

      return `<div class="right-col">
                <div  class="right-col__days">${string}</div>
              </div>`
    },
    toggleLine(id) {
      const el = Object.keys(this.DATA).find(i => this.DATA[i]['ID'] === id);
      if(el) {
        this.DATA[el]['OPEN'] = !this.DATA[el]['OPEN'];
      }

      if(Object.keys(this.DATA).find(i => this.DATA[i]["OPEN"] === true)) {
        this.all_open = true;
      }
    },
    updateCols() {
      if(document && document.querySelector('.right-col')) {
        this.width = document.querySelector('.right-col').clientWidth;
        this.count = this.width / 39

        this.fetchData({
          start: new Date(this.date).getTime(),
          count: this.count
        }).finally(() => {})
      }
    },
    dropAll() {
      if(this.DATA && Object.keys(this.DATA).length) {
        if(Object.keys(this.DATA).find(i => this.DATA[i]["OPEN"] === true)) {
          Object.keys(this.DATA).map(i => this.DATA[i]["OPEN"] = false);
          this.all_open = false;
        } else {
          Object.keys(this.DATA).map(i => this.DATA[i]["OPEN"] = true);
          this.all_open = true;
        }
      }
    },
    openPopup(parent_id, child_id, el_id) {
      this.togglePopup({
        parent_id,
        child_id,
        el_id
      })
    }
  },
  mounted() {
    this.date = new Date(new Date(new Date().toDateString()).getTime() - this.one_day).getTime();
    this.loading = false;
    this.fetchUser({auth: false}).finally(() => {
      this.updateCols();
    })

    document.toggleLine = this.toggleLine
    document.openPopup = this.openPopup
  }
}
</script>
